import React from 'react'
import classes from './subscriptioncard.module.css'
import { Button } from '../../Button/Button'
import classNames from 'classnames'
import { convertToFormatted } from '../../../util/functions'

//TODO Use cycle to generate amount per {whatever} info
const SubscriptionCard = ({
    title,
    amount,
    cycle,
    description,
    features,
    onSelect,
    className = '',
}) => {
    return (
        <div className={classNames(classes.card, className)}>
            <h1 className={classes.cardTitle}>{title}</h1>
            <h3 className={classes.cardPrice}>
                {convertToFormatted(amount, false, true)}
            </h3>
            <p className={classes.cardPriceCycle}>{cycle}</p>
            <p className={classes.cardDescription}>{description}</p>
            <h3 className={classes.cardPlanHeader}>
                <span className={classes.cardPlanHeaderText}>
                    Plan Includes
                </span>
            </h3>
            <div className={classes.cardPlans}>
                {features.map((feature, idx) => (
                    <p className={classes.cardPlan} key={idx}>
                        {feature}
                    </p>
                ))}
            </div>
            <Button onClick={onSelect} className={classes.cardButton}>
                SELECT PLAN
            </Button>
        </div>
    )
}

export default SubscriptionCard
